const localization = {
  de: 'Wir verwenden Cookies um Ihnen das bestmögliche Erlebnis auf unsere Webseite zu bieten. Durch die Weiternutzung dieser Website, geben Sie Ihre Einwilligung zur Verwendung von Cookies.',
  en: 'We use cookies to give you the best possible experience on our website. By continiuing to browse this site, you give consent for cookies to be used.',
  es: 'Usamos cookies para darte la mejor experiencia posible en nuestro sitio web. Si continúas navegando este sitio, otorgas tu consentimiento para el uso de cookies.',
  fr: 'Nous utilisons des cookies pour vous offrir la meilleure expérience possible sur notre site web. En continuant à parcourir ce site, vous acceptez l’utilisation des cookies.',
  nl: 'Wij gebruiken cookies om u de best mogelijke ervaring op onze website te bieden. Door verder gebruik van deze website, stemt u met het gebruik van deze cookies.',
}

export default localization



// WEBPACK FOOTER //
// ./src/components/CookieConsent/localization.js